export default __webpack_public_path__ + "static/media/add_identifier.0f193248.png";